import axios from 'axios'
import { Message } from 'element-ui'

const requests = axios.create({
  baseURL: '/api',
  timeout: 50000,
})

requests.interceptors.request.use((config) => {
  const authorization = localStorage.getItem('TOKEN')
  if (authorization) {
    config.headers['X-Auth-Token'] = authorization
  }
  return config
})

requests.interceptors.response.use(
  (res) => {
    return res.data
  },
  (err) => {
    if (err.response.status !== 200) {
      Message.error(err.response.data.msg)
    }
    // 后端的接口status只有200和500 token过期信息是在500接口里面的response.data中体现的
    // if (err.response.status === 401) {
    if (err.response.data.code === 401) {
      console.log(err.response.data.msg, 'err.response.data.msg')
      Message.error(err.response.data.msg)
      setTimeout(() => {
        localStorage.clear()
        window.location.replace('/login')
      })
    }
    return Promise.reject(err)
  }
)

export default requests
